
import { printf, toText } from "./fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { int32ToString } from "./fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { ofNullable } from "./fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { ensureValidToken } from "./Auth.js";
import { keyValueList } from "./fable_modules/fable-library-js.5.0.0-rc.2/MapUtil.js";
import { singleton as singleton_1, append } from "./fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { singleton, empty, append as append_1, delay, toList } from "./fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { Types_RequestProperties, Types_HttpRequestHeaders } from "./fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { Exception413, handleFetchError, httpException } from "./ErrorHandling.js";
import { singleton as singleton_2 } from "./fable_modules/fable-library-js.5.0.0-rc.2/AsyncBuilder.js";
import { awaitPromise } from "./fable_modules/fable-library-js.5.0.0-rc.2/Async.js";
import { Http_send, Headers_authorization, Headers_create, Headers_ifModifiedSince, Headers_pragma, Headers_contentType, Headers_cacheControl, Http_header, Http_request, Http_method, Http_content, Http_overrideResponseType } from "./fable_modules/Fable.SimpleHttp.3.6.0/Http.fs.js";
import { BodyContent, ResponseTypes } from "./fable_modules/Fable.SimpleHttp.3.6.0/Types.fs.js";
import { FSharpMap__get_Item } from "./fable_modules/fable-library-js.5.0.0-rc.2/Map.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "./fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise as promise_1 } from "./fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { Cmd_OfPromise_either } from "./fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";

export const addPrefix = (() => {
    const clo = toText(printf("/web%s"));
    return clo;
})();

export function errorString(response) {
    return (((int32ToString(response.status) + " ") + (response.statusText)) + " for URL ") + (response.url);
}

export function checkBuildDate(buildDate) {
    const oldBuildDate = ofNullable(localStorage.getItem("mwk_build_date"));
    if (oldBuildDate != null) {
        if (oldBuildDate === "") {
            const oldBuildDate_3 = oldBuildDate;
            localStorage.setItem("mwk_build_date", buildDate);
        }
        else if (oldBuildDate !== buildDate) {
            const oldBuildDate_4 = oldBuildDate;
            localStorage.setItem("mwk_build_date", buildDate);
            localStorage.removeItem("app-cache");
            localStorage.setItem("mwk_skip_cache_persist", "true");
            window.location.reload();
        }
    }
    else {
        localStorage.setItem("mwk_build_date", buildDate);
    }
}

export function fetchWithDecoder(iteration, url, init, contentType, decode) {
    const tenant = ofNullable(localStorage.getItem("tenant"));
    let pr_2;
    let pr_1;
    const pr = ensureValidToken();
    pr_1 = (pr.then((token_2) => fetch(url, keyValueList(append(singleton_1(new Types_RequestProperties(1, [keyValueList(toList(delay(() => {
        let matchValue;
        return append_1((matchValue = token_2, (matchValue == null) ? (empty()) : singleton(new Types_HttpRequestHeaders(5, ["Bearer " + matchValue]))), delay(() => append_1(singleton(new Types_HttpRequestHeaders(6, ["no-cache"])), delay(() => {
            let matchValue_1;
            return append_1((matchValue_1 = contentType, (matchValue_1 == null) ? (empty()) : singleton(new Types_HttpRequestHeaders(11, [matchValue_1]))), delay(() => append_1(singleton(new Types_HttpRequestHeaders(24, ["no-cache"])), delay(() => append_1(singleton(new Types_HttpRequestHeaders(18, ["0"])), delay(() => append_1(singleton(["Expires", "0"]), delay(() => {
                const matchValue_2 = tenant;
                if (matchValue_2 == null) {
                    return empty();
                }
                else {
                    return singleton(["X-ONE-Tenant", matchValue_2]);
                }
            }))))))));
        }))));
    })), 0)])), init), 1))));
    pr_2 = (pr_1.then((response) => {
        const matchValue_3 = (response.status) | 0;
        let matchResult, status;
        switch (matchValue_3) {
            case 400: {
                matchResult = 0;
                status = matchValue_3;
                break;
            }
            case 401: {
                matchResult = 0;
                status = matchValue_3;
                break;
            }
            case 403: {
                matchResult = 0;
                status = matchValue_3;
                break;
            }
            case 404: {
                matchResult = 0;
                status = matchValue_3;
                break;
            }
            case 413: {
                matchResult = 0;
                status = matchValue_3;
                break;
            }
            case 500: {
                matchResult = 0;
                status = matchValue_3;
                break;
            }
            default:
                matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                throw httpException(status, url);
            default: {
                checkBuildDate((response.headers).get("build-date"));
                return decode(response);
            }
        }
    }));
    return pr_2.then(void 0, (handleFetchError));
}

export function Async_fetchWithDecoder(iteration, url, body, method, contentType, decode) {
    const tenant = ofNullable(localStorage.getItem("tenant"));
    return singleton_2.Delay(() => {
        let pr;
        return singleton_2.Bind(awaitPromise((pr = ensureValidToken(), pr.then(void 0, (handleFetchError)))), (_arg) => {
            let request, req_6, req_5, req_4, req_3, req_2, request_1;
            const token = _arg;
            return singleton_2.Bind((request = Http_overrideResponseType(new ResponseTypes(2, []), (req_6 = ((req_5 = ((req_4 = ((req_3 = ((req_2 = Http_content(new BodyContent(1, [body]), Http_method(method, Http_request(url))), Http_header(Headers_cacheControl("no-cache"), req_2))), Http_header(Headers_contentType(contentType), req_3))), Http_header(Headers_pragma("no-cache"), req_4))), Http_header(Headers_ifModifiedSince("0"), req_5))), Http_header(Headers_create("Expires", "0"), req_6))), (request_1 = ((token == null) ? request : Http_header(Headers_authorization("Bearer " + token), request)), Http_send((tenant == null) ? request_1 : Http_header(Headers_create("X-ONE-Tenant", tenant), request_1)))), (_arg_1) => {
                let matchValue;
                const response = _arg_1;
                return singleton_2.ReturnFrom((matchValue = (response.statusCode | 0), (matchValue === 400) ? (() => {
                    throw httpException(matchValue, url);
                })() : ((matchValue === 401) ? (() => {
                    throw httpException(matchValue, url);
                })() : ((matchValue === 403) ? (() => {
                    throw httpException(matchValue, url);
                })() : ((matchValue === 404) ? (() => {
                    throw httpException(matchValue, url);
                })() : ((matchValue === 413) ? handleFetchError(new Exception413(url)) : ((matchValue === 500) ? (() => {
                    throw httpException(matchValue, url);
                })() : ((checkBuildDate(FSharpMap__get_Item(response.responseHeaders, "build-date")), decode(response))))))))));
            });
        });
    });
}

export function extractBlob(response, filename) {
    return PromiseBuilder__Run_212F1D4B(promise_1, PromiseBuilder__Delay_62FBFDE1(promise_1, () => (response.blob().then((_arg) => (Promise.resolve([_arg, filename]))))));
}

export function getBlob(response, filename, successMsg, errorMsg) {
    return Cmd_OfPromise_either((tupledArg) => extractBlob(tupledArg[0], tupledArg[1]), [response, filename], successMsg, errorMsg);
}

export function onBlobReceived(blob, filename) {
    const url = window.URL.createObjectURL(blob);
    const element = document.createElement("a");
    element.setAttribute("href", url);
    element.setAttribute("download", filename);
    document.body.appendChild(element);
    element.click();
    window.URL.revokeObjectURL(url);
    return element.remove();
}

